module.exports = __webpack_public_path__ + "img/app.fc55cf5c.svg";